import { defineMessages } from 'react-intl';

export default defineMessages({
    inputMustBeNumber: {
        id: 'premiumreport.gl.component.SublineDetailComponent.Input must be numeric',
        defaultMessage: 'Input must be numeric'
    },
    valueMustBeZeroOrGreater: {
        id: 'premiumreport.gl.component.SublineDetailComponent.Value must be zero or greater',
        defaultMessage: 'Value must be zero or greater'
    }
});
